import { Button, Input, Modal, Select } from "antd";
import styles from "./EditItemDetails.module.css";
import { useEffect, useRef } from "react";

const { Option } = Select;

const HomeBillDialog = ({
  homeDetailsOpen,
  setHomeDetailsOpen,
  qty,
  setQty,
  amount,
  setAmount,
  disCount,
  setDisCount,
  rate,
  setRate,
  disAmt,
  setDisAmt,
  productName,
  setProductName,
  designCode,
  setDesignCode,
  setPTypeName,
  setHsnCode,
  productData,
  setProductData,
  setBrandName,
  handleHomeBillSave,
}) => {
  const productRef = useRef(null);
  const designRef = useRef(null);
  const rateRef = useRef(null);
  const disPerRef = useRef(null);
  const disAmtRef = useRef(null);
  const saveRef = useRef(null);
  const handelCancel = () => {
    setHomeDetailsOpen(false);
    setQty(0);
    setAmount(0);
    setDisCount(0);
    setRate(0);
    setDisAmt(0);
    setProductName("");
    setDesignCode("");
    setPTypeName("");
    setHsnCode("");
    setBrandName("");
    setProductData([]);
  };
  useEffect(() => {
    if (homeDetailsOpen && productRef.current) {
      productRef.current.focus();
    }
  }, [homeDetailsOpen]);

  const handleProductChange = (value) => {
    setProductName(value);

    const selectedProduct = productData.find((p) => p.PRODNAME === value);

    if (selectedProduct) {
      setRate(selectedProduct.RATE || 0);
      setQty(1);
      const amt = 1 * selectedProduct.RATE;
      setAmount(amt || 0);
      setDisCount(0);
      setDisAmt(0);

      setHsnCode(selectedProduct.HSNCODE || "");
      setBrandName(selectedProduct.BRANDNAME || "");
      setPTypeName(selectedProduct.PTYPE || "");
      setTimeout(() => {
        designRef?.current?.focus();
      }, 0);
    } else {
      setRate(0);
      setQty(0);
      setDisCount(0);
      setDisAmt(0);
      setHsnCode("");
      setBrandName("");
      setPTypeName("");
      setAmount(0);
    }
  };

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextRef?.current) {
        nextRef.current.focus();
      }
    }
  };

  return (
    <Modal
      title={
        <strong
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            fontWeight: "bold",
            background: "#114a3d",
            borderRadius: "8px",
            padding: "4px 8px",
            color: "white",
          }}
        >
          Product Details
        </strong>
      }
      open={homeDetailsOpen}
      //   onCancel={handelCancel}
      closable={false}
      //   onOk={handelCancel}
      //   okText="OK"
      //   cancelText="Cancel"
      maskStyle={{
        backdropFilter: "blur(8px)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
      }}
      afterOpenChange={(open) => {
        if (open && productRef.current) {
          productRef.current.focus();
        }
      }}
      footer={null}
    >
      <div className={styles.cardContainer2}>
        <div className={styles.infoBox2}>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Design Code</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "18px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                  fontWeight: "bold",
                }}
                disabled
                value={designCode}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Product Name</span>
            <span className={styles.value2}>
              <Select
                allowClear
                showSearch
                placeholder="Select Product"
                style={{ width: 200 }}
                ref={productRef}
                value={productName || null}
                onChange={handleProductChange}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const inputText = e.target.value?.toLowerCase() || "";
                    const filtered = productData.filter((m) =>
                      m.PRODNAME.toLowerCase().includes(inputText),
                    );

                    if (filtered.length > 0) {
                      const selected = filtered[0].PRODNAME;
                      handleProductChange(selected);
                      setTimeout(() => {
                        designRef?.current?.focus();
                      }, 0);
                    }
                  }
                }}
              >
                {productData.map((pro, index) => (
                  <Option key={index} value={pro.PRODNAME}>
                    {pro.PRODNAME}
                  </Option>
                ))}
              </Select>
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Qty</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Qty"
                ref={designRef}
                disabled={!productName}
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                value={qty}
                onFocus={(e) => e.target.select()}
                onChange={(e) => {
                  const val = e.target.value;

                  if (/^\d*\.?\d{0,2}$/.test(val)) {
                    const amt = val * rate;

                    setQty(val);
                  }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, rateRef);
                }}
              />
            </span>
          </div>

          {/* WASTAGE */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Rate</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Rate"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                ref={rateRef}
                disabled={!productName}
                value={rate}
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(val)) {
                    const disPer = disCount;
                    const rateValue = val * disPer;
                    const dAmt = rateValue / 100;
                    const ActRate = val - dAmt;

                    setRate(val);
                    setDisAmt(dAmt);
                    setAmount(ActRate);
                  }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, disPerRef);
                }}
              />
            </span>
          </div>

          {/* DIRECTWT */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Dis Per(%)</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Dis Per"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                ref={disPerRef}
                disabled={!productName}
                value={disCount}
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (!/^\d*\.?\d*$/.test(val)) return;
                  const updatedValue = val === 0 ? 0 : Number(val);
                  const cRate = rate;
                  const rateValue = cRate * val;
                  const disAmt = rateValue / 100;
                  const ActRate = cRate - disAmt;

                  setDisCount(updatedValue);
                  setDisAmt(disAmt);
                  setAmount(ActRate);
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, disAmtRef);
                }}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Dis Amt</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Dis Amt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                ref={disAmtRef}
                disabled={!productName}
                value={disAmt ?? 0}
                onFocus={(e) => e.target.select()} // Select entire value
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(val)) {
                    const rateValue = rate;
                    const ActRate = rateValue - val;

                    setDisAmt(val);
                    setAmount(ActRate);
                  }
                }}
                onKeyDown={(e) => {
                  handleKeyDown(e, saveRef);
                }}
              />
            </span>
          </div>

          {/* TOTALWT */}
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Act Rate</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                disabled
                value={Number(amount)?.toFixed(2)}
              />
            </span>
          </div>
          <div className={styles.rowTag2}>
            <span className={styles.label2}>Amount</span>
            <span className={styles.value2}>
              <Input
                placeholder="Enter Total Wt"
                style={{
                  width: "200px",
                  height: 32,
                  fontSize: "16px",
                  backgroundColor: "AppWorkspace",
                  color: "black",
                }}
                disabled
                value={Number(qty * amount)?.toFixed(2)}
              />
            </span>
          </div>
        </div>
      </div>
      <div
        style={{
          textAlign: "right",
          marginTop: 10,
          display: "flex",
          justifyContent: "right",
          gap: "10px",
        }}
      >
        <Button
          onClick={() => {
            handelCancel();
          }}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #BF092F",
            color: "#BF092F",
            borderRadius: "8px",
            width: 100,
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          ref={saveRef}
          disabled={!productName || rate <= 0}
          onClick={() => {
            handleHomeBillSave();
          }}
          style={{
            width: 100,
            backgroundColor: "#006400",
            borderRadius: "8px",
          }}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};
export default HomeBillDialog;
